<template>
  <view class="dialog-show-slot-demo">
    <cube-button  bind:click="onClickDialog">Dialog - title & content slot</cube-button>
    <cube-dialog  wx:ref="dialogWithSlot" confirm-btn="我知道了">
      <view class="dialog-show-slot-title" slot="title">
        <image class="show-slot-img" mode="aspectFit" src="https://dpubstatic.udache.com/static/dpubimg/911dcd99-4fe5-43b3-9178-6a25d9847be8.png"></image>
      </view>
      <view class="dialog-show-slot-content" slot="content">我是slot-content</view>
    </cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  methods: {
    onClickDialog () {
      const dialogRef = this.$refs.dialogWithSlot
      dialogRef.show()
    }
  }
})
</script>

<style lang="stylus">
.dialog-show-slot-content
  text-align center
.show-slot-img
  width 100%
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>
